import {
    $get,
    $post, $post2
} from './httpRequest'
import axios from 'axios'
var baseurl = '/permissions'
var api = '/applyqrcode'

// // 图片上传
// export function uploadNewsImage(params) {
//   var url ='/applyqrcode/uploadFile'
//   return $post(url, params)
// }

// 企业端---管理系统
//企业登录
export function login(params) {
    var url = baseurl + '/companyUserLogin/login'
    return $post(url, params)
}
//首次登录修改密码
export function resetPwd(params) {
    var url = api + '/regist/resetPwd'
    return $post(url, params)
}

// // 首页获取数据
// export function getCompanyData() {
//   var url = api + '/homePage/homePage'
//   return $post(url)
// }

//获取企业用户菜单信息
export function queryCompanyUserMenus() {
    var url = baseurl + '/companyUsers/queryCompanyUserMenus'
    return $post(url)
}
//请求验证码
export function sendCode(phone) {
    var url = baseurl + '/regist/sendTelphoneCode'
    var params = {
        telphone: phone
    }
    return $post(url, params)
}
//校验手机号是否重复
export function validateTelphone(telphone) {
    var url = baseurl + '/regist/validateTelphone'
    var params = {
        telphone
    }
    return $post(url, params)
}
//验证手机验证码
export function validateTelphoneCode({
    telphone,
    smsCode
}) {
    var url = baseurl + '/regist/validateTelphoneCode'
    var params = {
        telphone,
        smsCode
    }
    return $post(url, params)
}
// 修改密码
export function updateUserPassword(params) {
    var url = baseurl + '/regist/updateUserPassword'
    return $post(url, params)
}
//获取标识
export function queryUserFlag() {
    var url = baseurl + '/regist/queryUserFlag'
    var params = {}
    return $post(url, params)
}

//验证图片验证码
export function validateImgCode(params) {
    var url = baseurl + '/regist/validateImgCode'
    return $post(url, params)
}
//校验用户名是否重复
export function validateAccountName(name) {
    var url = baseurl + '/regist/validateAccountName'
    var params = {
        accountName: name
    }
    return $post(url, params)
}

//上传营业执照图片 
export function uploadBusinessLicence(params) {
    var url = '/applyqrcode/officalHome/uploadBusinessLicence'
    return $post(url, params)
}
// 企业修改密码
export function changePasword(params) {
    var url = '/permissions/adminLogin/changePassword'
    return $post(url, params)
}
//产品类型列表
export function getProductTypeList(params) {
    var url = '/applyqrcode/productionType/queryList'
    return $post(url, params)
}
//产品分页列表
export function getProductPageList(params) {
    var url = '/applyqrcode/offiicalProduct/getProductList'
    return $post(url, params)
}
//同步物料列表
export function syncProduct(params) {
    var url = '/applyqrcode/yuntuDataSync/syncProduct'
    return $get(url, params)
}
// 产品物料任务查询
export function getSyncTaskById(params) {
    var url = '/applyqrcode/syncTask/getSyncTaskById'
    return $post(url, params)
}
//查看正在进行的同步任务
export function syncCurrentTask(params) {
    var url = 'applyqrcode/syncTask/getLastSyncTask'
    return $post(url, params)
}
// 所有产品列表
export function getAllProductList(params) {
    var url = '/applyqrcode/offiicalProduct/getList'
    return $post(url, params)
}
//新增产品信息
export function addProduct(params) {
    var url = '/applyqrcode/offiicalProduct/addProduction'
    return $post(url, params)
}
//修改产品信息
export function editProduct(params) {
    var url = '/applyqrcode/offiicalProduct/editProduct'
    return $post(url, params)
}
// 获取产品详情
export function getProductInfo(params) {
    var url = '/applyqrcode/offiicalProduct/queryById'
    return $post(url, params)
}

//导出产品列表
export function exportProductList(params) {
    axios.defaults.responseType = 'blob';
    var url = '/applyqrcode/offiicalProduct/exportXML'
    return $post(url, params)
}

// 获取字典类型
export function getDictTypeList(params) {
    var url = '/applyqrcode/companyDictType/queryList'
    return $post(url, params)
}

//获取属性全部列表
export function getAttributeList(params) {
    var url = '/applyqrcode/productPropertyDeploy/queryList'
    return $post(url, params)
}

//获取属性分页列表
export function getDictPageList(params) {
    var url = '/applyqrcode/productPropertyDeploy/queryPage'
    return $post(url, params)
}
// 校检属性名称
export function checkAttributeName(params) {
    var url = '/applyqrcode/productPropertyDeploy/checkName'
    return $post(url, params)
}
// 校检属性编码
export function checkAttributeCode(params) {
    var url = '/applyqrcode/productPropertyDeploy/checkCode'
    return $post(url, params)
}
//新增或修改属性
export function saveOrUpdateArrribute(params) {
    var url = '/applyqrcode/productPropertyDeploy/addOrUpdate'
    return $post(url, params)
}
//查看属性详情
export function arrributeDetails(params) {
    var url = '/applyqrcode/productPropertyDeploy/queryById'
    return $post(url, params)
}

//删除字典信息
export function delDict(params) {
    var url = '/applyqrcode/companyDict/delDict'
    return $post(url, params)
}

//上传图片 
export function uploadImage(params) {
    var url = '/applyqrcode/officalHome/uploadBusinessLicence'
    return $post(url, params)
}

//新增或修改经销商信息
export function saveOrUpdateDealer(params) {
    var url = '/applyqrcode/companyInfo/saveOrUpdateByAdmin'
    return $post(url, params)
}
//经销商分页列表
export function getDealerPageList(params) {
    var url = '/applyqrcode/companyInfo/queryPage'
    return $post(url, params)
}
//同步经销商
export function syncAgent(params) {
    var url = '/applyqrcode/yuntuDataSync/syncAgent'
    return $get(url, params)
}
//经销商列表
export function getDealerList(params) {
    var url = '/applyqrcode/companyInfo/queryList'
    return $post(url, params)
}
//查询所有入网经销商
export function getDealerOnlineList(params) {
    var url = '/applyqrcode/companyInfo/queryDealList'
    return $post(url, params)
}
//导出经销商
export function exportDealer(params) {
    axios.defaults.responseType = 'blob';
    var url = '/applyqrcode/companyInfo/exportDealer'
    return $post(url, params)
}
//设置销售区域
export function bindDealCompany(params) {
    var url = '/permissions/companyInfo/bindDealCompany'
    return $post(url, params)
}
// 校检经销商编码
export function checkDealerCode(params) {
    var url = '/applyqrcode/companyInfo/checkDealerCode'
    return $post(url, params)
}
// 校检产品编码
export function checkProductCode(params) {
    var url = '/applyqrcode/offiicalProduct/checkProductCode'
    return $post(url, params)
}
// 产品详情
export function productDetail(params) {
    var url = '/applyqrcode/offiicalProduct/beforeUpdateProduct'
    return $post(url, params)
}
// 产品对应扫码页模板
export function productScanTemp(params) {
    var url = '/applyqrcode/companyProductTemp/queryTemp'
    return $post(url, params)
}
//扫码模板
export function productScanTempList(params) {
    var url = '/applyqrcode/companyProductTemp/queryList'
    return $post(url, params)
}
// 修改产品模板
export function updateTemp(params) {
    var url = '/applyqrcode/companyProductTemp/updateTemp'
    return $post(url, params)
}
// 扫码预览
export function scanCodePreview(params) {
    var url = '/applyqrcode/regist/queryCode'
    return $post(url, params)
}
//刷新
export function refreshCode(params) {
    var url = '/applyqrcode/regist/resetCodeCount'
    return $post(url, params)
}

//入库文件上传
export function inFileUpload(params) {
    var url = '/applyqrcode/productImportLibrary/uploadAndParse'
    return $post(url, params)
}
// 入库列表
export function inWarehouseList(params) {
    var url = '/applyqrcode/productImportLibrary/queryPageList'
    return $post(url, params)
}
// 出库文件上传
export function outFileUpload(params) {
    var url = '/applyqrcode/productExportLibrary/uploadAndParse'
    return $post(url, params)
}
// 出库列表
export function outWarehouseList(params) {
    var url = '/applyqrcode/productExportLibrary/queryPageList'
    return $post(url, params)
}
// 修改经销商
export function updateDealer(params) {
    var url = '/applyqrcode/productExportLibrary/edit'
    return $post(url, params)
}


// 库存查询
export function queryStockPageList(params) {
    var url = '/applyqrcode/productRepertory/queryPageList'
    return $post(url, params)
}
// 库存导出
export function exportStock(params) {
    axios.defaults.responseType = 'blob';
    var url = '/applyqrcode/productRepertory/exportProductRepertory'
    return $post(url, params)
}



// 经销商入库分页列表
export function dealerInWarehouseList(params) {
    var url = '/applyqrcode/productImportLibrarySell/queryPageList'
    return $post(url, params)
}
// 确认入库
export function sureInWarehouse(params) {
    var url = '/applyqrcode/productImportLibrarySell/updateStatus'
    return $post(url, params)
}

// 经销商出库分页列表
export function dealerOutWarehouseList(params) {
    var url = '/applyqrcode/productExportLibrary/queryPageList'
    return $post(url, params)
}
// 经销商库存分页列表
export function dealerStockList(params) {
    var url = '/applyqrcode/productRepertory/queryPageList'
    return $post(url, params)
}
// 查询经销商列表
export function queryDealerList(params) {
    var url = '/applyqrcode/companyInfo/queryAllDeal'
    return $post(url, params)
}
// 查询产品列表
export function queryProductList(params) {
    var url = '/applyqrcode/productImportLibrarySell/getProductList'
    return $post(url, params)
}
// 出库新增
export function agencySaveOrEdit(params) {
    var url = '/applyqrcode/productExportLibrary/agencySaveOrEdit'
    return $post(url, params)
}


// 退货分页列表
export function productReturnsPageList(params) {
    var url = '/applyqrcode/companyProductRecede/querypage'
    return $post(url, params)
}
// 导入退货文件XML
export function importReturnsFile(params) {
    var url = '/applyqrcode/companyProductRecede/importRedeceXML'
    return $post(url, params)
}
// 导出退货列表EXcel
export function exportReturns(params) {
    axios.defaults.responseType = 'blob';
    var url = '/applyqrcode/companyProductRecede/exportExcel'
    return $post(url, params)
}
// 查看详细信息
export function returnsDetails(params) {
    var url = '/applyqrcode/companyProductRecede/queryById'
    return $post(url, params)
}
// 查看退货追溯码
export function queryReturnsTracecode(params) {
    var url = '/applyqrcode/companyProductRecede/queryAllTracecode'
    return $post(url, params)
}
// 重置追溯码
export function resetTracecode(params) {
    var url = '/applyqrcode/companyProductRecede/resetStatus'
    return $post(url, params)
}

// 企业信息管理
export function getCompanyInfo(params) {
    var url = '/applyqrcode/introDuction/getIntroDuction'
    return $post(url, params)
}
// 企业信息管理
export function saveCompanyInfo(params) {
    var url = '/applyqrcode/introDuction/addOrEditIntro'
    return $post(url, params)
}
// 统计分析----- 出库统计
export function outHouseStatistics(params) {
    var url = '/applyqrcode/productExportLibraryRecord/productStoreOutStatistics'
    return $post(url, params)
}
// 退货统计
export function returnsStatistics(params) {
    var url = '/applyqrcode/companyRecedeStatis/statistiChart'
    return $post(url, params)
}


//申请码的请求路径 /applyqrcode
//码关联查询
export function queryTraceByCode(params) {
    var url = '/applyqrcode/traceCodeQuery/queryByTraceCode'
    return $post(url, params)
}
//获取企业用户的申请码列表
export function queryTracecodeApplyList(params) {
    var url = '/applyqrcode/tracecodeApply/adminQueryTracecodeApplyList'
    return $post(url, params)
}

// 申请码申请列表
export function traceCodeApplyList(params) {
    var url = '/applyqrcode/tracecodeApply/queryAccountTraceCodeList'
    return $post(url, params)
}

// 下载追溯码
export function downloadTracecode(params) {
    axios.defaults.responseType = 'blob';
    var url = '/permissions/hweiYunOBS/download/' + params
    return $post(url, params)
}
// 窜货列表
export function getfeelingPage(params) {
    var url = '/applyqrcode/offiicalProduct/queryWarningSetPageList'
    return $post(url, params)
}
//修改阀值
export function savePath(params) {
    var url = '/applyqrcode/warningLevel/patchSave'
    return $post(url, params)
}
// 统一设置
export function saveSinglePath(params) {
    var url = '/applyqrcode/warningLevel/saveOrUpdate'
    return $post(url, params)
}
// 窜货统计
export function statisticsPageList(params) {
    var url = '/applyqrcode/traceCodeUnnormalRecordAdmin/statisticsPageList'
    return $post(url, params)
}
// 窜货明细
export function statisticsDetailList(params) {
    var url = '/applyqrcode//traceCodeUnnormalRecordAdmin/queryObject'
    return $post(url, params)
}

//撤销申请码
export function cancelTraceApply(params) {
    var url = '/applyqrcode/tracecodeApply/cancelTraceApply'
    return $post(url, params)
}
//企业用户激活申请码 //添加生产日期 //服务商申请码确认 //服务商下载申请码
export function updateTracecodeApplyStatus(params) {
    var url = '/applyqrcode/tracecodeApply/updateTracecodeApplyStatus'
    return $post(url, params)
}
//企业用户根据登录信息获取自己的产品列表
export function getProductionProductList() {
    var url = '/applyqrcode/tracecodeApply/getProductionProductList'
    return $post(url)
}
//保存申请码
export function saveTracecodeApplyMain(params) {
    var url = '/applyqrcode/tracecodeApply/saveTracecodeApplyMain'
    return $post(url, params)
}
//获取单个tracecode信息
export function queryTracecodeApply(params) {
    var url = '/applyqrcode/tracecodeApply/queryTracecodeApply'
    return $post(url, params)
}
//防窜管理
export function getScanRecords(params) {
    var url = '/applyqrcode/traceCodeUnnormalRecord/queryPageList'
    return $post(url, params)
}
// 服务管理
// 企业账户   初始化信息
export function getInitInfo(params) {
    var url = '/applyqrcode/companyInfoInit/queryInitInfo'
    return $post(url, params)
}
// 企业账户   套餐列表-购买记录
export function getPackageList(params) {
    var url = '/package/companyPackage/queryList'
    return $post(url, params)
}
// 购买标码、套餐
export function buyCode(params) {
    var url = '/package/userPackageDetriment/addPackageDetriment'
    return $post(url, params)
}
// 购买服务
export function buyService(params) {
    var url = '/applyqrcode/companyServicePurchase/payServiceCharge'
    return $post(url, params)
}
//购买服务历史记录
export function buyServiceHistory(params) {
    var url = '/applyqrcode/companyServicePurchase/queryLog'
    return $post(url, params)
}

//塑业企业获取追溯码列表
export function queryTracecodeList(params) {
    var url = '/applyqrcode/tracecodeApply/queryTracecodeApplyList'
    return $post(url, params)
}


//服务商
//获取企业用户的申请码列表 
export function queryTracecodeApplyListByService(params) {
    var url = '/applyqrcode/tracecodeApply/queryTracecodeApplyListByService'
    return $post(url, params)
}


// 运营端---管理系统
// 审核列表
export function companyAuditList(params) {
    var url = '/applyqrcode/companyInfo/getCompanyInfoList'
    return $post(url, params)
}
// 保存 审核企业信息
export function saveCompanyAudit(params) {
    var url = '/applyqrcode/companyInfo/saveAudit'
    return $post(url, params)
}
// 扫码模板分页列表
export function getScanPageList(params) {
    var url = '/applyqrcode/tracecodeTemplate/queryPage'
    return $post(url, params)
}
// 扫码模板所有列表      
export function getScanAllList(params) {
    var url = '/applyqrcode/tracecodeTemplate/queryList'
    return $post(url, params)
}
// 校检模板编码   
export function checkTempCode(params) {
    var url = '/applyqrcode/tracecodeTemplate/checkTempCode'
    return $post(url, params)
}
// 新增扫码模板
export function scanTempAddOrUpdate(params) {
    var url = '/applyqrcode/tracecodeTemplate/addOrUpdate'
    return $post(url, params)
}
// 企业模板关联列表
export function getCompanyTempPage(params) {
    var url = '/applyqrcode/companyTemp/queryPage'
    return $post(url, params)
}
// 给企业配置扫码模板
export function addCompanyTemp(params) {
    var url = '/applyqrcode/companyTemp/addCompanyTemp'
    return $post(url, params)
}
// 企业参数配置
export function updateCompanySite(params) {
    var url = '/applyqrcode/companyInfoInit/updateSite'
    return $post(url, params)
}

// 查看使用企业
export function queryUseCompany(params) {
    var url = '/applyqrcode/tracecodeTemplate/queryUseCompany'
    return $post(url, params)
}

//登录
export function adminLogin(params) {
    var url = '/permissions/adminLogin/login'
    return $post(url, params)
}


// 官网获取新闻分页列表
export function getWebNewsList(params) {
    var url = '/applyqrcode/newsIntroduction/getFreeNewsListPage'
    return $post(url, params)
}
// 官网新闻详情
export function getWebNewsDetail(params) {
    var url = '/applyqrcode/newsIntroduction/getNewsIntroductionById'
    return $get(url, params)
}
// 获取新闻分页列表
export function getNewsList(params) {
    var url = '/applyqrcode/newsIntroduction/getNewsListPage'
    return $post(url, params)
}

// 新增新闻资讯
export function saveNewsIntroduction(params) {
    var url = '/applyqrcode/newsIntroduction/saveNewsIntroduction'
    return $post(url, params)
}
//修改资讯内容
export function updateNewsIntroduction(params) {
    var url = '/applyqrcode/newsIntroduction/updateNewsIntroduction'
    return $post(url, params)
}


//进入首页
export function toindex() {
    var url = '/permissions/adminbus/toindex'
    return $post(url)
}
///获取前台和后台菜单(界面管理)
export function getMenus(params) {
    var url = '/permissions/systemNavi/getMenus'
    return $post(url, params)
}
//获取系统后台按钮权限
export function getMenuBtn() {
    var url = '/permissions/systemNavi/getMenuBtn'
    return $post(url)
}
//根据菜单id查询菜单详情
export function getTreeById(params) {
    var url = '/permissions/systemNavi/getTreeById'
    return $post(url, params)
}
//保存修改 新增菜单
export function saveMenuList(params) {
    var url = +'/permissions/systemNavi/save'
    return $post(url, params)
}
// 删除导航菜单
export function deletedMenu(params) {
    var url = '/permissions/systemNavigation/deleteSystemNavigation'
    return $post(url, params)
}
// 删除导航菜单
export function deletedCompanyMenu(params) {
    var url = '/permissions/companyNavigation/deleteCompanyNavigation'
    return $post(url, params)
}
//查询系统角色
export function getRolesList(params) {
    var url = '/permissions/systemRoles/getRolesList'
    return $post(url, params)
}
//查询用户角色
export function getCompanyRolesList(params) {
    var url = '/permissions/systemRoles/getCompanyRolesList'
    return $post(url, params)
}

//查询已选用户角色
export function getTreeCheckedId(params) {
    var url = '/permissions/systemNavi/getPermissionNaviList'
    return $post(url, params)
}

//系统角色权限
export function getPermissionTree(params) {
    var url = '/permissions/systemNavi/getPermissionTree'
    return $post(url, params)
}
//角色删除
export function deleteSystemRole(params) {
    var url = '/permissions/systemRoles/delete'
    return $post(url, params)
}
//角色新增
export function saveRoles(params) {
    var url = '/permissions/systemRoles/save'
    return $post(url, params)
}
//新增角色的是否查询角色是否存在
export function nameIsExist(params) {
    var url = '/permissions/systemRoles/nameIsExist'
    return $post(url, params)
}
// 管理员修改密码
export function adminChangePwd(params) {
    var url = '/permissions//adminLogin/changePassword'
    return $post(url, params)
}
//企业信息
export function companyInfoPage() {
    var url = baseurl + '/permissions/companyInfo/companyInfoPage'
    return $post(url)
}
//企业未审核列表
export function comanyInfoList(params) {
    var url = 'applyqrcode/companyInfo/getCompanyInfoList'
    return $post(url, params)
}
//企业审核后列表
export function comanyPageList(params) {
    var url = 'applyqrcode/companyInfo/queryAllCompany'
    return $post(url, params)
}
//塑业企业列表
export function queryPlasticCompany(params) {
    var url = 'applyqrcode/companyInfo/queryPlasticCompany'
    return $post(url, params)
}
//修改企业状态
export function companyUpdateStatus(params) {
    var url = 'applyqrcode/companyInfo/updateStatus'
    return $post(url, params)
}

// 新增客户
export function saveAddCompany(params) {
    var url = 'applyqrcode/companyInfo/adminUserSaveCompanyInfo'
    return $post(url, params)
}
// 编辑企业
export function saveEditCompany(params) {
    var url = 'applyqrcode/companyInfo/updateCompanyInfoAndSaveUser'
    return $post(url, params)
}
//企业详情
export function companyInfoDetail(params) {
    var url = '/applyqrcode/companyInfo/companyInfoDetail'
    return $post(url, params)
}
//潜在客户列表
export function companyPoten(params) {
    var url = '/applyqrcode/companyPoten/queryPage'
    return $post(url, params)
}
//删除潜在客户
export function companyPotenDelete(params) {
    var url = '/applyqrcode/companyPoten/delById'
    return $post(url, params)
}
// 保存意向客户
export function saveCompanyPoten(params) {
    var url = '/applyqrcode/regist/savePoten'
    return $post(url, params)
}

//查询企业code是否存在
export function codeExits(params) {
    var url = baseurl + '/companyInfo/codeExits'
    return $post(url, params)
}
//保存企业审核信息
export function saveAudit(params) {
    var url = baseurl + '/companyInfo/saveAudit'
    return $post(url, params)
}
//企业审核
export function companyAudited(params) {
    var url = baseurl + '/companyInfo/companyAudited'
    return $post(url, params)
}
//企业编辑
export function companyEdit(params) {
    var url = baseurl + '/companyInfo/companyEdit'
    return $post(url, params)
}
// 同步企业到营销平台
export function synSystemCompanyInfo(params) {
    var url = api + '/marketingSystem/synSystemCompanyInfo'
    return $post(url, params)
}
// 同步追溯码信息
export function synSystemTraceCodeApplyMain(params) {
    var url = api + '/marketingSystem/synSystemTraceCodeApplyMain'
    return $post(url, params)
}
//标码申请 /applyqrcode

// 码规则配置
export function saveOrUpdateTraceCodeRule(params) {
    var url = api + '/traceCodeRule/saveOrUpdate'
    return $post(url, params)
}

// 码规则列表
export function traceCodeRulePageList(params) {
    var url = api + '/traceCodeRule/queryPage'
    return $post(url, params)
}

//码规则配置-企业列表
export function getTracecodeRuleCompanyList(params) {
    var url = api + '/companyTracecodeRule/getCompanyInfoList'
    return $post(url, params)
}

//企业码配置列表
export function getCompanyTracecodeRuleList(params) {
    var url = api + '/companyTracecodeRule/queryList'
    return $post(url, params)
}
//获取码规则列表
export function getAllTracecodeRuleList(params) {
    var url = api + '/traceCodeRule/queryList'
    return $post(url, params)
}
//保存配置企业码规则/修改企业默认规则
export function saveOrUpdateCompanyTracecodeRule(params) {
    var url = api + '/companyTracecodeRule/saveOrUpdate'
    return $post(url, params)
}

// 新增申请码
export function saveTracecodeApply1(params) {
    var url = api + '/tracecodeApply/saveTracecodeApplyMain'
    return $post(url, params)
}
export function saveTracecodeAdminApply1(params) {
    var url = api + '/tracecodeApply/saveTracecodeApplyMainByAdmin'
    return $post(url, params)
}
export function saveTracecodeApply2(params) {
    var url = api + '/tracecodeApplyAdmin/saveTracecodeApplyMainAuditing'
    return $post(url, params)
}
// 基地列表
export function getProductionBaseList(params) {
    var url = '/applyqrcode/companyInfo/queryProductionBase'
    return $post(url, params)
}

// 扫码模板分页列表
export function scanTempletePageList(params) {
    var url = '/applyqrcode/tracecodeTemplate/queryPage'
    return $post(url, params)
}
// 扫码模板分页列表
export function scanTempleteAddOrUpdate(params) {
    var url = '/applyqrcode/tracecodeTemplate/addOrUpdate'
    return $post(url, params)
}

//扫码
export function scanCode(code, params) {
    var url = '/applyqrcode/' + code
    return $post(url, params)
}
export function getWxConfig(params) {
    var url = '/applyqrcode/regist/getJsApiSignature'
    return $post(url, params)
}
// 导出入库
export function exportProductImportLibrary(params) {
    axios.defaults.responseType = 'blob';
    var url = '/applyqrcode/productImportLibrary/exportProductImportLibrary'
    return $post2(url, params)
}

// 编辑物料
export function saveProduct(params) {
    var url = '/applyqrcode/offiicalProduct/saveOrUpdateByAdmin'
    return $post(url, params)
}
//信德过通用功能
//添加企业log
export function addLogo(params) {
    var url = '/permissions/intoDuction/addLogo'
    return $post(url, params)
}
//查看企业logo 
export function lookLogo() {
    var url = '/permissions/intoDuction/lookLogo'
    return $post(url)
}
//公司简介信息的新增和修改
export function addOrEditIntro(params) {
    var url = '/permissions/intoDuction/addOrEditIntro'
    return $post(url, params)
}
//获取当前企业的简介信息
export function getIntroDuction() {
    var url = '/permissions/intoDuction/getIntroDuction'
    return $post(url)
}
//新增商品简介
export function addOrEditProDuctIntro(params) {
    var url = '/applyqrcode/productIntro/addOrEditProDuctIntro'
    return $post(url, params)
}
//品牌推广-修改状态
export function proDuctIntroUpdateStatus(params) {
    var url = '/applyqrcode/productIntro/updateStatus'
    return $post(url, params)
}
//产品简介分页
export function getproductIntro(params) {
    var url = '/applyqrcode/productIntro/getproductIntro'
    return $post(url, params)
}
//查看单个产品简介详情接口
export function getProductDetails(params) {
    var url = '/applyqrcode/productIntro/getProductDetails'
    return $post(url, params)
}
//添加或编辑关联企业
export function saveOrEditCompany(params) {
    var url = '/permissions/companyRelevance/saveOrEdit'
    return $post(url, params)
}


//后台管理员查看所有流程配置 permissions
export function getFlows(params) {
    var url = '/permissions/companyflow/getFlows'
    return $post(url, params)
}
//添加流程信息
export function addFlow(params) {
    var url = '/permissions/companyflow/addFlow'
    return $post(url, params)
}
//更改流程信息状态
export function updateStatus(params) {
    var url = '/permissions/companyflow/updateStatus'
    return $post(url, params)
}
//返回企业列表
export function getFlowsCompanyInfos(params) {
    var url = '/applyqrcode/companyInfo/getCompanyInfos'
    return $post(url, params)
}

//后台管理系统  system 接口
// 获取用户导航菜单
export function getUserNavList(params) {
    var url = baseurl + '/systemNavigation/getSystemNavigation'
    return $post(url, params)
}
//获取所有菜单列表
export function getSystemAllNavList(params) {
    var url = baseurl + '/systemNavigation/getSystemNavigationTree'
    return $post(url, params)
}
// 组织架构树
export function queryOrganizationByCurrentUser(params) {
    var url = baseurl + '/systemOrganization/queryOrganizationByCurrentUser'
    return $post(url, params)
}
//获取组织架构的分页列表
export function getOrganizationList(params) {
    var url = baseurl + '/systemOrganization/queryPageList'
    return $post(url, params)
}
//修改组织架构排序号
export function updateOrgSort(params) {
    var url = baseurl + '/systemOrganization/updateSort'
    return $post(url, params)
}
//修改组织架构状态
export function updateOrgStatus(params) {
    var url = baseurl + '/systemOrganization/updateStatus'
    return $post(url, params)
}
//新增或编辑组织架构
export function saveOrEditOrg(params) {
    var url = baseurl + '/systemOrganization/saveOrEdit'
    return $post(url, params)
}
//获取系统角色分页列表
export function getSystemRolesListPage(params) {
    var url = baseurl + '/systemRoles/getSystemRolesListPage'
    return $post(url, params)
}
//新增角色
export function saveSystemRoles(params) {
    var url = baseurl + '/systemRoles/saveSystemRoles'
    return $post(url, params)
}
export function updateSystemRoles(params) {
    var url = baseurl + '/systemRoles/updateSystemRoles'
    return $post(url, params)
}
//修改角色状态
export function updateRolesStatus(params) {
    var url = baseurl + '/systemRoles/updateStatusById'
    return $post(url, params)
}
//获取该角色拥有的菜单
export function getRoleNavigationTree(params) {
    var url = baseurl + '/systemNavigation/getSystemNavigation'
    return $post(url, params)
}
//获取该角色拥有的菜单id--(角色配置权限回显)
export function getSystemNavigationId(params) {
    var url = baseurl + '/systemNavigation/getPermissionNaviListByRolesId'
    return $post(url, params)
}
//保存权限配置
export function saveRolesNav(params) {
    var url = baseurl + '/systemRoles/distributePermission'
    return $post(url, params)
}
// 企业角色父级分页列表
export function getSystemRolesFatherCompanyList(params) {
    var url = baseurl + '/systemRoles/getSystemRolesFatherCompanyList'
    return $post(url, params)
}
// 企业角色子级列表
export function getSystemRolesSonCompanyList(params) {
    var url = baseurl + '/systemRoles/getSystemRolesSunCompanyList'
    return $post(url, params)
}
//职务分页列表
export function queryPositionPageList(params) {
    var url = baseurl + '/systemRank/queryPageList'
    return $post(url, params)
}
//职务列表
export function queryPositionList(params) {
    var url = baseurl + '/systemRank/queryList'
    return $post(url, params)
}
//获取系统所有角色
export function getSystemRolesList(params) {
    var url = baseurl + '/systemRoles/getSystemRolesList'
    return $post(url, params)
}
// 新增或编辑职位
export function saveOrEditPosition(params) {
    var url = baseurl + '/systemRank/saveOrEdit'
    return $post(url, params)
}
//修改职位状态
export function updatePositionStatus(params) {
    var url = baseurl + '/systemRank/updateStatus'
    return $post(url, params)
}
// 人员管理
// 获取平台人员的分页列表
export function queryPersonList(params) {
    var url = baseurl + '/systemUser/queryPageList'
    return $post(url, params)
}
//根据ID获取一条平台人员数据
export function getPersonObject(params) {
    var url = baseurl + '/systemUser/queryObject'
    return $post(url, params)
}
//新增或编辑人员
export function saveOrEditPerson(params) {
    var url = baseurl + '/systemUser/saveOrEdit'
    return $post(url, params)
}
//变更人员状态
export function updatePersonStatus(params) {
    var url = baseurl + '/systemUser/updateStatus'
    return $post(url, params)
}
//查看人员权限
export function getPersonNaviList(params) {
    var url = baseurl + '/systemNavigation/getPermissionNaviListByUserId'
    return $post(url, params)
}
//获取按钮列表
export function getSystemMenuBtn(params) {
    var url = baseurl + '/systemMenuBtn/queryList'
    return $post(url, params)
}
//添加系统导航菜单
export function saveSystemMenuBtn(params) {
    var url = baseurl + '/systemNavigation/saveSystemNavigation'
    return $post(url, params)
}
//修改系统导航
export function updateSystemMenuBtn(params) {
    var url = baseurl + '/systemNavigation/updateSystemNavigation'
    return $post(url, params)
}
//给菜单分配按钮
export function distributeNavigationMenu(params) {
    var url = baseurl + '/systemNavigation/distributeNavigationMenuBtn'
    return $post(url, params)
}
//查看菜单分配的按钮
export function getNavigationMenuBtn(params) {
    var url = baseurl + '/systemNavigation/getNavigationMenuBtn'
    return $post(url, params)
}
//企业信息-修改角色（获取角色）
export function queryChildrenRolesByCompanyType(params) {
    var url = baseurl + '/systemRoles/queryChildrenRolesByCompanyType'
    return $post(url, params)
}
//企业信息-修改角色（获取当前企业的角色）
export function queryCompanyRoleId(params) {
    var url = baseurl + '/companyUserClient/queryCompanyRoleId'
    return $post(url, params)
}
//企业信息-修改角色（提交）
export function updateRoleDistribution(params) {
    var url = baseurl + '/companyRolesPer/updateRoleDistribution'
    return $post(url, params)
}
// //获取企业所有菜单
export function getAllCompanyNavigation(params) {
    var url = baseurl + '/companyNavigation/getCompanyNavigationTree'
    return $post(url, params)
}
//企业--获取菜单tree(企业给员工分配权限用)
export function getAdminNavigationByUserId(params) {
    var url = baseurl + '/companyNavigation/getAdminNavigationByUserId'
    return $post(url, params)
}
//企业--新增导航菜单
export function saveCompanyNavigation(params) {
    var url = baseurl + '/companyNavigation/saveCompanyNavigation'
    return $post(url, params)
}
//企业--修改导航菜单
export function updateCompanyNavigation(params) {
    var url = baseurl + '/companyNavigation/updateCompanyNavigation'
    return $post(url, params)
}
//企业--给企业菜单分配按钮（提交）
export function distributeNavigationMenuBtnCompany(params) {
    var url = baseurl + '/companyNavigation/distributeNavigationMenuBtn'
    return $post(url, params)
}
//企业--查看菜单绑定的按钮（回显）
export function getNavigationMenuBtnCompany(params) {
    var url = baseurl + '/companyNavigation/getNavigationMenuBtn'
    return $post(url, params)
}
//保存企业权限配置
export function saveCompanyRolesNav(params) {
    var url = baseurl + '/systemRoles/distributePermission'
    return $post(url, params)
}
//获取企业权限和按钮（回显）
export function getCompanyPermissionNaviListByRolesId(params) {
    var url = baseurl + '/companyNavigation/getPermissionNaviListBySystemRolesId'
    return $post(url, params)
}
//按钮管理
//按钮分页列表
export function queryMenuBtnList(params) {
    var url = baseurl + '/systemMenuBtn/queryPageList'
    return $post(url, params)
}
//新增按钮
export function saveOrEditMenuBtn(params) {
    var url = baseurl + '/systemMenuBtn/saveOrEdit'
    return $post(url, params)
}
//修改状态
export function updateMenuStatus(params) {
    var url = baseurl + '/systemMenuBtn/updateStatus'
    return $post(url, params)
}
//生产企业-组织架构树
export function companyQueryOrganizationByCurrentUser(params) {
    var url = baseurl + '/companyOrganizationPer/queryOrganizationByCurrentUser'
    return $post(url, params)
}
//生产企业-组织架构分页列表
export function getCompanyOrganizationList(params) {
    var url = baseurl + '/companyOrganizationPer/queryPageList'
    return $post(url, params)
}
//生产企业-组织架构新增、编辑
export function saveOrEditCompanyOrganization(params) {
    var url = baseurl + '/companyOrganizationPer/saveOrEdit'
    return $post(url, params)
}
//生产企业-组织架构修改状态
export function updateCompanyOrgStatus(params) {
    var url = baseurl + '/companyOrganizationPer/updateStatus'
    return $post(url, params)
}

// //生产企业-角色分页列表
export function getCompanyRolesListPage(params) {
    var url = baseurl + '/companyRolesPer/getCompanyRolesListPage'
    return $post(url, params)
}
//生产企业-角色列表
export function getCompanyRolesLi(params) {
    var url = baseurl + '/companyRolesPer/getCompanyRolesList'
    return $post(url, params)
}
// //生产企业-角色新增、编辑
export function saveCompanyRoles(params) {
    var url = baseurl + '/companyRolesPer/saveCompanyRoles'
    return $post(url, params)
}
export function updateCompanyRoles(params) {
    var url = baseurl + '/companyRolesPer/updateCompanyRoles'
    return $post(url, params)
}
//生产企业-给角色配置权限
export function distributeCompanyRoles(params) {
    var url = baseurl + '/companyRolesPer/distributePermission'
    return $post(url, params)
}
// //生产企业-角色变更状态
export function updateCompanyRolesStatus(params) {
    var url = baseurl + '/companyRolesPer/updaStatusById'
    return $post(url, params)
}
//角色分配权限 回显
export function getPermissionNaviListByCompanyRolesId(params) {
    var url = baseurl + '/companyNavigation/getPermissionNaviListByRolesId'
    return $post(url, params)
}

// 生产企业-职务分页列表
export function queryCompanyPositionPageList(params) {
    var url = baseurl + '/companyRankPer/queryPageList'
    return $post(url, params)
}
// 生产企业-职务新增、编辑
export function saveOrEditCompanyPosition(params) {
    var url = baseurl + '/companyRankPer/saveOrEdit'
    return $post(url, params)
}
// 生产企业-修改职务状态
export function updateCompanyPositionStatus(params) {
    var url = baseurl + '/companyRankPer/updateStatus'
    return $post(url, params)
}
//生产企业-职务列表
export function queryCompanyPositionList(params) {
    var url = baseurl + '/companyRankPer/queryList'
    return $post(url, params)
}

// 生产企业-人员分页列表C
export function queryCompanyPersonPageList(params) {
    var url = baseurl + '/companyUserClient/queryPageList'
    return $post(url, params)
}
// 生产企业-人员新增或编辑
export function saveOrEditCompanyUser(params) {
    var url = baseurl + '/companyUserClient/saveOrEdit'
    return $post(url, params)
}
// 生产企业-修改人员状态
export function updateCompanyUserStatus(params) {
    var url = baseurl + '/companyUserClient/updateStatus'
    return $post(url, params)
}

//生产企业-查看人员权限
export function getCompanyPersonNaviList(params) {
    var url = baseurl + '/companyNavigation/getPermissionNaviListByUserId'
    return $post(url, params)
}

//生产企业-根据ID获取一条平台人员数据
export function getCompanyPersonObject(params) {
    var url = baseurl + '/companyUserClient/queryObject'
    return $post(url, params)
}
// 新增塑业企业
export function addPlasticCompany(params) {
    var url = '/applyqrcode/companyInfo/adminUserSaveCompanyInfo'
    return $post(url, params)
}
// 编辑塑业企业
export function editPlasticCompany(params) {
    var url = '/applyqrcode/companyInfo/updateCompanyInfoAndSaveUser'
    return $post(url, params)
}

// 同步工厂
export function syncFactory(params) {
    var url = '/applyqrcode/yuntuDataSync/syncFactory'
    return $get(url, params)
}
// 物料品牌列表
export function getBrandPageList(params) {
    var url = '/applyqrcode/productionBrand/queryPage'
    return $post(url, params)
}
// 新增/编辑物料品牌
export function addOrUpdateBrand(params) {
    var url = '/applyqrcode/productionBrand/addOrUpdate'
    return $post(url, params)
}
// 物料品牌所有列表
export function getBrandList(params) {
    var url = '/applyqrcode/productionBrand/queryList'
    return $post(url, params)
}
// 首页数量
export function getIndexStatistics(params) {
    var url = '/applyqrcode/queryPageData/queryPageData'
    return $post(url, params)
}
// 出库管理导出
export function exportOutboundReport(params) {
    axios.defaults.responseType = 'blob';
    var url = '/applyqrcode/productExportLibrary/exportOutboundReport'
    return $post(url, params)
}
// 窜货统计导出
export function exportCounterfeitGoodsReport(params) {
    axios.defaults.responseType = 'blob';
    var url = '/applyqrcode/traceCodeUnnormalRecordAdmin/exportCounterfeitGoodsReport'
    return $post(url, params)
}


// WEBPACK FOOTER //
// ./src/common/api.js